import { render, staticRenderFns } from "./ThreeDSecure.vue?vue&type=template&id=5fa7bccf&scoped=true&"
import script from "./ThreeDSecure.vue?vue&type=script&lang=js&"
export * from "./ThreeDSecure.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDSecure.vue?vue&type=style&index=0&id=5fa7bccf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7bccf",
  null
  
)

export default component.exports